import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { HeroSection } from './sections/HeroSection';
import { AboutSection } from './sections/AboutSection';
import { LiveWaitlistPreview } from './sections/LiveWaitlistPreview';
import { ServicesSection } from './sections/ServicesSection';
import { FeaturesSection } from './sections/FeaturesSection';
import { ReviewsSection } from './sections/ReviewsSection';
import { HoursSection } from './sections/HoursSection';
import { ContactSection } from './sections/ContactSection';

export const LandingPage = () => {
  return (
    <div className="min-h-screen bg-stone-50">
      <Header />
      <main>
        <HeroSection />
        <LiveWaitlistPreview />
        <AboutSection />
        <FeaturesSection />
        <ServicesSection />
        <ReviewsSection />
        <HoursSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};
